// extracted by mini-css-extract-plugin
export var label = "_ah-1";
export var reminder = "_ah-0";